
    import {Vue, Component} from "vue-property-decorator";
    import {ApiRepository} from '@/api';

    @Component({
        components: {
        },
        props: {
        },
    })
    export default class UserDelete extends Vue {
        public async mounted() {
            const userId = this.$route.params.user;
            await ApiRepository.deleteUser(userId);
        }
    }
